import { useEffect, useRef, RefObject } from 'react'

type UseDialogDismissOptions = {
  dialogRef: RefObject<HTMLDivElement | null>
  onClose: () => void
  disabled?: boolean
}

export const useDialogDismiss = ({
  dialogRef,
  onClose,
  disabled = false,
}: UseDialogDismissOptions): void => {
  const isMouseDownInsideRef = useRef(false)

  useEffect(() => {
    if (disabled) return

    const handleMouseDown = (event: MouseEvent) => {
      isMouseDownInsideRef.current = Boolean(
        dialogRef.current?.contains(event.target as Node),
      )
    }

    const handleMouseUp = (event: MouseEvent) => {
      const isMouseUpInside = dialogRef.current?.contains(event.target as Node)

      if (!isMouseDownInsideRef.current && !isMouseUpInside) {
        onClose()
      }
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleMouseDown)
    document.addEventListener('mouseup', handleMouseUp)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
      document.removeEventListener('mouseup', handleMouseUp)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [dialogRef, onClose, disabled])
}
